import React, { useContext } from "react";
import { ThemeContext } from "../contexts/theme-context";

const Sidebar = (props) => {
  const { theme, setTheme } = useContext(ThemeContext);

  const handleThemeChange = () => {
    const isCurrentDark = theme === "dark";
    const activeTheme = isCurrentDark ? "light" : "dark";
    setTheme(activeTheme);
    localStorage.setItem("theme", activeTheme);
  };

  return (
    <section className="sidebar">
      <div className="sidebar_inner">
        <button onClick={handleThemeChange} className="change_theme_btn">
          {theme === "light" ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffc107"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="5"></circle>
              <line x1="12" y1="1" x2="12" y2="3"></line>
              <line x1="12" y1="21" x2="12" y2="23"></line>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
              <line x1="1" y1="12" x2="3" y2="12"></line>
              <line x1="21" y1="12" x2="23" y2="12"></line>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
            </svg>
          )}
        </button>
        <div className="profile_img">
          <img src="/shubham-pandey.jpeg" alt="shubham pandey" />
        </div>

        <div className="para_box">
          <h1 className="name">Shubham Pandey</h1>
          <p>
            Currently Software engineer{" "}
            <a
              href="https://dtdl.in/"
              rel="noreferrer"
              target="_blank"
              className="linkcss"
            >
              @Deutsche Telekom
            </a>
            . Formerly Senior Associate{" "}
            <a
              href="https://www.infosys.com/"
              rel="noreferrer"
              target="_blank"
              className="linkcss"
            >
              @Infosys
            </a>
          </p>
        </div>

        <div className="social_icon_box">
          <a
            href="https://www.facebook.com/kautilyshubham"
            rel="noreferrer"
            target="_blank"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              className="social_icon"
            >
              <title>facebook</title>
              <path d="M31.997 15.999c0-8.836-7.163-15.999-15.999-15.999s-15.999 7.163-15.999 15.999c0 7.985 5.851 14.604 13.499 15.804v-11.18h-4.062v-4.625h4.062v-3.525c0-4.010 2.389-6.225 6.043-6.225 1.75 0 3.581 0.312 3.581 0.312v3.937h-2.017c-1.987 0-2.607 1.233-2.607 2.498v3.001h4.437l-0.709 4.625h-3.728v11.18c7.649-1.2 13.499-7.819 13.499-15.804z"></path>
            </svg>
          </a>
          <a
            href="https://www.linkedin.com/in/kautilyshubham/"
            rel="noreferrer"
            target="_blank"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              className="social_icon"
            >
              <title>linkedin</title>
              <path d="M27.263 27.269h-4.739v-7.425c0-1.771-0.036-4.049-2.469-4.049-2.471 0-2.848 1.927-2.848 3.919v7.556h-4.739v-15.269h4.552v2.081h0.061c0.636-1.2 2.183-2.467 4.493-2.467 4.801 0 5.689 3.16 5.689 7.273v8.381zM7.116 9.911c-1.525 0-2.751-1.235-2.751-2.753 0-1.517 1.227-2.751 2.751-2.751 1.52 0 2.752 1.233 2.752 2.751 0 1.519-1.233 2.753-2.752 2.753zM9.492 27.269h-4.752v-15.269h4.752v15.269zM29.633 0h-27.272c-1.305 0-2.361 1.032-2.361 2.305v27.389c0 1.275 1.056 2.305 2.361 2.305h27.268c1.304 0 2.371-1.031 2.371-2.305v-27.389c0-1.273-1.067-2.305-2.371-2.305h0.004z"></path>
            </svg>
          </a>
          <a
            href="https://www.behance.net/kautilyshubham"
            rel="noreferrer"
            target="_blank"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              className="social_icon"
            >
              <title>behance</title>
              <path d="M9.251 6.004c0.936 0 1.787 0.080 2.56 0.251 0.769 0.173 1.427 0.44 1.98 0.813 0.547 0.373 0.977 0.867 1.28 1.493 0.3 0.627 0.453 1.4 0.453 2.307 0 0.987-0.227 1.813-0.676 2.48-0.451 0.667-1.116 1.2-2.003 1.627 1.208 0.347 2.101 0.96 2.696 1.827 0.597 0.88 0.887 1.933 0.887 3.147 0 1-0.173 1.853-0.547 2.573-0.373 0.733-0.893 1.333-1.547 1.8-0.64 0.464-1.4 0.8-2.227 1.023-0.813 0.22-1.669 0.339-2.547 0.339h-9.561v-19.669h9.251v-0.009zM22.587 22.22c0.587 0.571 1.431 0.857 2.525 0.857 0.787 0 1.467-0.197 2.040-0.596 0.565-0.387 0.907-0.813 1.040-1.253h3.451c-0.537 1.707-1.397 2.933-2.533 3.667-1.133 0.747-2.512 1.107-4.107 1.107-1.116 0-2.112-0.173-3.029-0.533-0.897-0.36-1.653-0.867-2.293-1.52-0.619-0.653-1.097-1.44-1.436-2.36-0.337-0.92-0.497-1.933-0.497-3.027 0-1.071 0.18-2.053 0.537-2.973 0.36-0.933 0.859-1.707 1.493-2.387 0.66-0.68 1.417-1.193 2.315-1.592s1.867-0.577 2.96-0.577c1.213 0 2.253 0.219 3.173 0.697 0.893 0.453 1.627 1.093 2.213 1.867 0.587 0.781 1 1.68 1.253 2.693 0.253 1 0.333 2.053 0.28 3.173h-10.253c0 1.12 0.373 2.176 0.947 2.753l-0.107 0.040zM8.933 22.287c0.423 0 0.827-0.040 1.208-0.124 0.387-0.080 0.731-0.22 1.017-0.4 0.28-0.18 0.52-0.437 0.693-0.777 0.173-0.32 0.253-0.76 0.253-1.28 0-1-0.293-1.72-0.853-2.16-0.573-0.427-1.32-0.64-2.253-0.64h-4.679v5.4h4.613v-0.040zM27.076 14.753c-0.469-0.513-1.253-0.789-2.209-0.789-0.624 0-1.14 0.099-1.555 0.317-0.403 0.2-0.733 0.467-0.987 0.787s-0.423 0.64-0.523 1c-0.1 0.347-0.16 0.667-0.18 0.947h6.349c-0.093-1-0.44-1.733-0.907-2.253v0.013zM8.693 13.933c0.765 0 1.4-0.179 1.9-0.549 0.499-0.36 0.739-0.96 0.739-1.784 0-0.459-0.093-0.833-0.24-1.128-0.173-0.293-0.4-0.52-0.667-0.683-0.28-0.165-0.6-0.28-0.96-0.343-0.36-0.071-0.747-0.099-1.12-0.099h-4.039v4.587h4.387zM20.824 7.323h7.957v1.939h-7.957v-1.941z"></path>
            </svg>
          </a>
          <a
            href="https://github.com/kautilyshubham"
            rel="noreferrer"
            target="_blank"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              className="social_icon"
            >
              <title>github</title>
              <path d="M16 0.396c-8.84 0-16 7.164-16 16 0 7.071 4.584 13.067 10.94 15.18 0.8 0.151 1.093-0.344 1.093-0.769 0-0.38-0.013-1.387-0.020-2.72-4.451 0.965-5.389-2.147-5.389-2.147-0.728-1.847-1.78-2.34-1.78-2.34-1.449-0.992 0.112-0.972 0.112-0.972 1.607 0.112 2.451 1.648 2.451 1.648 1.427 2.447 3.745 1.74 4.66 1.331 0.144-1.035 0.556-1.74 1.013-2.14-3.553-0.4-7.288-1.776-7.288-7.907 0-1.747 0.62-3.173 1.647-4.293-0.18-0.404-0.72-2.031 0.14-4.235 0 0 1.34-0.429 4.4 1.64 1.28-0.356 2.64-0.532 4-0.54 1.36 0.008 2.72 0.184 4 0.54 3.040-2.069 4.38-1.64 4.38-1.64 0.86 2.204 0.32 3.831 0.16 4.235 1.020 1.12 1.64 2.547 1.64 4.293 0 6.147-3.74 7.5-7.3 7.893 0.56 0.48 1.080 1.461 1.080 2.96 0 2.141-0.020 3.861-0.020 4.381 0 0.42 0.28 0.92 1.1 0.76 6.401-2.099 10.981-8.099 10.981-15.159 0-8.836-7.164-16-16-16z"></path>
            </svg>
          </a>
          <a
            href="https://www.hackerearth.com/@kautilyshubham"
            rel="noreferrer"
            target="_blank"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              className="social_icon"
            >
              <title>hackerearth</title>
              <path d="M27.977 0.003h-15.3v8.659h0.147c0.894-1.14 2.271-1.865 3.817-1.865 0.327 0 0.647 0.032 0.956 0.094l-0.031-0.005-0.031-0.005c2.621 0.192 5.213 1.781 5.36 6.877v10.072c-0.008 0.208-0.175 0.374-0.382 0.383l-0.001 0h-2.813c-0.211 0-0.383-0.171-0.383-0.383v0-9.763c0-2.371-0.78-4.152-3.121-4.152h-0.051c-1.919 0-3.474 1.556-3.474 3.475 0 0.082 0.003 0.163 0.008 0.243l-0.001-0.011v-0.011 10.22c0 0.211-0.171 0.383-0.383 0.383v0h-2.797c-0.211 0-0.383-0.171-0.383-0.383v0-23.825l-4.948-0.001c-1.097 0-1.991 0.869-2.031 1.957v27.983c0.040 1.143 0.973 2.055 2.12 2.061h23.723c1.049-0.031 1.888-0.889 1.888-1.943 0-0.043-0.001-0.087-0.004-0.129l0 0.006v0.005-27.979c0.002-0.036 0.004-0.077 0.004-0.119 0-1.016-0.824-1.84-1.84-1.84v0l-0.051 0.001h0.003zM24.591 27.98h-17.184v-1.767h17.184z"></path>
            </svg>
          </a>
        </div>
        <div className="button_box">
          <a href="tel: +91 9111112293" className="touch_btn">
            Get In Touch
          </a>
        </div>
      </div>
    </section>
  );
};

export default Sidebar;
